import React from 'react';
import PropTypes from 'prop-types';
import { Console, ConsoleHeader, Text } from '@brandwatch/axiom-components';

import InviteMessage from '../InviteMessage.jsx';

import './InfoConsole.css';

class InfoConsole extends React.Component {
  render() {
    const { deck, invite, inviteeCount } = this.props;
    const deckName = deck ? deck.name : '';

    return (
      <Console position="right" width="20rem" theme="day">
        <ConsoleHeader separator={true} size="large">
          <Text
            className="InfoConsole__Heading"
            textSize="headline"
            space="x0"
            textStrong
            textColor="subtle"
          >
            {deckName}
          </Text>
        </ConsoleHeader>
        <div className="InfoConsole__Content">
          <InviteMessage invite={invite} inviteeCount={inviteeCount} />
        </div>
      </Console>
    );
  }
}

InfoConsole.propTypes = {
  deck: PropTypes.object,
  invite: PropTypes.object,
  inviteeCount: PropTypes.number
};

export default InfoConsole;
